import { connect } from 'react-redux';

// Components:
import CertificateErrorPopup from '../components/CertificateErrorPopup';

// Hocs:
import withMobile from '../hocs/withMobile';

// Actions:
import { goToOrderAction } from '../store/view/sagaActions';
import { hideErrorPopup } from '../store/view/slice';

// Selectors:
import { getIsErrorShown, getErrorMessage } from '../store/view/selectors';
import { getOrderId } from '../../../store/payment/selectors';

const mapStateToProps = (state) => ({
  isOpen: getIsErrorShown(state),
  orderId: getOrderId(state),
  errorMessage: getErrorMessage(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(hideErrorPopup()),
  goToOrder: () => dispatch(goToOrderAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(CertificateErrorPopup));
